<script lang="ts">
	import { imgSrc, imgSrcSet } from "$lib/serv/image-details";
	import { geoOpted$, setGeoOpted } from "$lib/serv/locations";
	import { selectAddress } from "$lib/ui/modals/AddressModal.svelte";
	import { onDestroy, onMount } from "svelte";

	export let images:[string?,string?][] = [];

	let activeImage: string|undefined;
	let activeImageMobile: string|undefined;
	let index = 0;

	if (images?.length) ([activeImage, activeImageMobile] = images[index]);
	let timer: any;

	async function currentLocation() {
		setGeoOpted();
		selectAddress();
	}

	onMount(() => {
		timer = setInterval(() => {
			if (!images?.length) return;
			index = (index + 1) % images.length;
			([activeImage, activeImageMobile] = images[index]);
		}, 2500);
	})

	onDestroy(() => clearInterval(timer));
</script>

<section class="img_slider">
	<article>
		<img {...imgSrcSet(activeImageMobile)} class="narrow" alt="Shop takeout, Pick n Pay groceries, pet care, liquor, gifting & more">
		<img {...imgSrcSet(activeImage)} class="wide" alt="Shop takeout, Pick n Pay groceries, pet care, liquor, gifting & more">
	</article>
	<div>
		<h4 class="headline-m">Shop takeout, Pick n Pay groceries, pet care, liquor, gifting & more</h4>
		<div class="buttons">
			<button class="button primary" on:click={() => selectAddress()}><span class="icon-pin-outline-20"></span> Enter address</button>
			{#if !$geoOpted$}
				<button class="button tertiary" on:click={(e) => currentLocation()}><span class="icon-current-location-20"></span> Use current location</button>
			{/if}
		</div>
	</div>
</section>

<style lang="scss">
	@use 'color';
	@use 'screen';

	.img_slider {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100%;
		margin: 4rem 0;
		@media(min-width: 720px) { margin: 6rem 0; }
		@media(screen.$md) { margin: 7rem 0; }
		@media(screen.$mdl) { margin: 9rem 0; }
		@media(screen.$lg) { margin: 10rem 0; }
		article {
			position: relative;
			width: 100%;
			max-width: 500px;
			aspect-ratio: 1/1;
			border-radius: 50px;
			box-shadow: 0 2px 12px 4px rgba(0,0,0,.2);
			overflow: hidden;
			@media(screen.$sm) {
				max-width: unset;
				aspect-ratio: 16/9;
			}
			@media(screen.$lg) { border-radius: 80px; }
			>img {
				// position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				object-fit: cover;
				&.wide {
					display: none;
					@media(min-width: 720px) { display: block; }
				}
				&.narrow {
					@media(min-width: 720px) { display: none; }
				}
			}
		}
		>div {
			position: relative;
			@media(screen.$md) {
				position: absolute;
				background: color.$white;
				border-radius: 36px;
				padding: 1.4rem;
				bottom: 1.4rem;
				left: 1.4rem;
			}
			@media(screen.$lg) {
				border-radius: 42px;
				padding: 1.5rem;
				bottom: 2.4rem;
				left: 2.4rem;
			}
			h4 {
				text-align: center;
				margin: 1rem 0 1.75rem 0;
				max-width: 400px;
				@media(screen.$sm) { max-width: 470px; }
				@media(screen.$md) {
					color: color.$black; 
					text-align: left;
					margin: 0rem 0 1.35rem 0;
				}
				@media(screen.$lg) { max-width: 500px; }
			}
			.buttons {
				display: flex;
				flex-direction: column;
				align-items: center;
				.primary {
					margin: 0 0 1rem 0;
					@media(screen.$md) { margin: 0 .8rem 0 0; }
				}
				@media(screen.$md) {
					flex-direction: row;
					color: color.$black;
				}
				button {
					span { margin-right: 8px; }
				}
			}
		}
	}
</style>